<template>
  <div
    class="d-flex search-input"
    :class="{ 'primary-border': internalSearchInputFocus }"
  >
    <i class="material-icons search-icon">search</i>
    <b-form-input
      @blur="() => (internalSearchInputFocus = false)"
      @focus="() => (internalSearchInputFocus = true)"
      @update="value => $emit('updateSearch', value)"
      :placeholder="searchLabel"
    />
  </div>
</template>
<script>
export default {
  props: {
    searchInputFocus: {
      type: Boolean,
      default: false,
    },
    searchLabel: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.internalSearchInputFocus = this.searchInputFocus
  },
  data() {
    return {
      internalSearchInputFocus: false,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.search-input {
  border: 1px solid map-get($theme-colors, 'gray01');
  border-radius: 30px;

  input[type='text'] {
    background-color: map-get($theme-colors, 'white') !important;
    border: none;
    padding: 0;
    margin: 0;
  }
}
.search-icon {
  color: map-get($theme-colors, 'gray01');
  font-size: 30px;
  line-height: 16px;
  padding: 18px 0 0 15px;
  z-index: 10;
  opacity: 0.2;
}
</style>
